import React, {useCallback, useEffect} from "react";
import PersonalDataComponent from "../components/data/user/PersonalDataComponent";
import {handleValidatedApiException, unsetJwt, useHttp} from "../services/HttpService";
import {getAnwenderMe, putAnwenderProfile} from "../services/AnwenderService";
import {useForm} from "../utils/FormUtils";
import {useHttpSortById} from "../utils/usePreformattedHttp";
import {getAnredeEndpoint, getTitelEndpoint} from "../services/WertelistenService";
import LoadingPlaceholder from "../components/LoadingPlaceholder";
import {createPersonSchema} from "../initialObjects/AnwenderObjects";
import EAButton from "../components/EAButton";
import EAButtonBar from "../components/EAButtonBar";
import {changeFieldValueIfPresent} from "../utils/ObjectUtils";
import {useConfirmation} from "../components/ConfirmationDialog/ConfirmationDialogProvider";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import routes from "../consts/routes.json";

export default function ProfilView() {
    const confirm = useConfirmation();
    const history = useHistory();
    const [{data: anwender, loading}] = useHttp(getAnwenderMe);
    const [titelOptionen] = useHttpSortById(getTitelEndpoint);
    const [anredeOptionen] = useHttpSortById(getAnredeEndpoint);
    const {values, setValues, touchedValues, setTouchedValues, formFactory, errors, submit, submitLoading} = useForm({
        schema: {person: createPersonSchema()},
    });

    useEffect(() => {
        if (anwender) {
            setValues(anwender);
        }
    }, [anwender, setValues]);

    function handleKontaktChanged(field, value) {
        const valueToSet = {...values};
        valueToSet.person[field] = value;
        setTouchedValues((oldTouchedValues) => {
            const newTouchedValues = {...oldTouchedValues};
            newTouchedValues[field] = true;
            return newTouchedValues;
        });
        setValues(valueToSet);
    }

    const prepareValues = useCallback((valueCopy) => {
        changeFieldValueIfPresent(valueCopy.person, "organisation", "id");
        return valueCopy;
    }, []);

    function handleSave() {
        let message = "";
        if (touchedValues.benutzername || touchedValues.passwort || touchedValues.email) {
            message = "Sie werden nach dem Speichern abgemeldet und können sich mit den neuen Daten anmelden. ";
        }
        if (touchedValues.email) {
            message += "Sie müssen Ihre geänderte E-Mail-Adresse vor dem Login bestätigen.";
        }
        if (message) {
            confirm({
                title: "Profil speichern",
                description: message,
                onClose: () => {
                },
                onSubmit: () => {
                    submit(prepareValues, putAnwenderProfile, "PUT")
                        .then(() => {
                            toast.success("Das Profil wurde erfolgreich aktualisiert.");
                            history.push(routes.LOGOUT);
                            unsetJwt();
                        })
                        .catch((e) => handleValidatedApiException(e, "Error saving Profil"));
                },
            });
        } else {
            submit(prepareValues, putAnwenderProfile, "PUT")
                .then(() => {
                    toast.success("Das Profil wurde erfolgreich aktualisiert.");
                })
                .catch((e) => handleValidatedApiException(e, "Error saving Profil"));
        }
    }

    const isLoading = useCallback(() => {
        return loading || !values.person;
    }, [loading, values.person]);

    return (
        <div style={{margin: "var(--tabsheet-content-top-spacing) var(--horizontal-spacing) var(--vertical-spacing)"}}>
            {isLoading() ? (
                <LoadingPlaceholder/>
            ) : (
                <PersonalDataComponent
                    person={values.person}
                    anredeOptions={anredeOptionen}
                    titelOptions={titelOptionen}
                    errors={errors}
                    handlePersonChanged={handleKontaktChanged}
                    additionalChildren={
                        <React.Fragment>
                            {formFactory.renderInput("benutzername", "benutzername", "Benutzername", "text", false, {
                                style: {gridColumn: 1},
                            })}
                            {formFactory.renderInput("passwort", "passwort", "Passwort", "password", false, {
                                InputProps: {autoComplete: "new-password"},
                            })}
                        </React.Fragment>
                    }
                    additionalPersonField={null}
                />
            )}
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EAButton
                    loading={isLoading() || submitLoading}
                    disabled={isLoading() || submitLoading}
                    id={"btnOk"}
                    data-cy={"btnOk"}
                    color="primary"
                    label={"Speichern"}
                    onClick={() => handleSave()}
                />
            </EAButtonBar>
        </div>
    );
}
